export const consumerInsights = {
  "tab_name": "consumer-insights",
  "data": [
    {
      "name": "University of Hull",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 85
        },
        {
          "name": "Career Outcomes",
          "value": 92
        },
        {
          "name": "Learning Experience",
          "value": 87
        },
        {
          "name": "Value for Money",
          "value": 25
        },
        {
          "name": "International Recognition",
          "value": 82.0
        },
        {
          "name": "Employability Prospects",
          "value": 38
        },
        {
          "name": "Campus Life",
          "value": 80
        },
        {
          "name": "Research Quality",
          "value": 82
        }
      ]
    },
    {
      "name": "Warwick Business School",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 89
        },
        {
          "name": "Career Outcomes",
          "value": 97
        },
        {
          "name": "Learning Experience",
          "value": 91
        },
        {
          "name": "Value for Money",
          "value": 18
        },
        {
          "name": "International Recognition",
          "value": 90.0
        },
        {
          "name": "Employability Prospects",
          "value": 42
        },
        {
          "name": "Campus Life",
          "value": 85
        },
        {
          "name": "Research Quality",
          "value": 88
        }
      ]
    }
  ],
  "table": [
    {
      "university": "University of Hull",
      "enrollment_rate": 83.3,
      "student_satisfaction": 85,
      "career_placement": 92,
      "average_salary": 53000,
      "employability_score": 38,
      "digital_perception": 78,
      "retention_rate": 90,
      "international_students": 55,
      "work_experience": 4.5,
      "study_mode": 80
    },
    {
      "university": "Warwick Business School",
      "enrollment_rate": 84.0,
      "student_satisfaction": 89,
      "career_placement": 97,
      "average_salary": 60000,
      "employability_score": 42,
      "digital_perception": 90,
      "retention_rate": 94,
      "international_students": 70,
      "work_experience": 6,
      "study_mode": 90
    }
  ],
  "chart": {
    "title": "Consumer Insights Analysis - MBA Programs in UK",
    "subtitle": "Student Satisfaction, Career Outcomes, and Learning Experience Comparison",
    "chart_type": "radar",
    "x_axis": "Metrics",
    "y_axis": "Score (0-100)",
    "series": [
      {
        "name": "University of Hull",
        "series": [
          {
            "name": "Student Satisfaction",
            "value": 85
          },
          {
            "name": "Career Outcomes",
            "value": 92
          },
          {
            "name": "Learning Experience",
            "value": 87
          },
          {
            "name": "Value for Money",
            "value": 25
          },
          {
            "name": "International Recognition",
            "value": 82.0
          },
          {
            "name": "Employability Prospects",
            "value": 38
          },
          {
            "name": "Campus Life",
            "value": 80
          },
          {
            "name": "Research Quality",
            "value": 82
          }
        ]
      },
      {
        "name": "Warwick Business School",
        "series": [
          {
            "name": "Student Satisfaction",
            "value": 89
          },
          {
            "name": "Career Outcomes",
            "value": 97
          },
          {
            "name": "Learning Experience",
            "value": 91
          },
          {
            "name": "Value for Money",
            "value": 18
          },
          {
            "name": "International Recognition",
            "value": 90.0
          },
          {
            "name": "Employability Prospects",
            "value": 42
          },
          {
            "name": "Campus Life",
            "value": 85
          },
          {
            "name": "Research Quality",
            "value": 88
          }
        ]
      }
    ],
    "options": {
      "responsive": true,
      "maintainAspectRatio": false,
      "scales": {
        "r": {
          "beginAtZero": true,
          "max": 100,
          "ticks": {
            "stepSize": 20
          }
        }
      }
    }
  },
  "details": {
    "summary": "Comprehensive analysis of 2 universities offering MBA programs in UK",
    "key_findings": [
      "Student satisfaction varies significantly across universities",
      "Career outcomes are strongly correlated with university reputation",
      "International recognition impacts student decision-making",
      "Value for money considerations vary by institution type"
    ],
    "methodology": "Analysis based on enrollment data, satisfaction surveys, career outcomes, and student preferences",
    "data_freshness": "Data current as of 2024-2025",
    "confidence_level": "High",
    "sample_size": "Analysis covers 2 major universities"
  },
  "evidence_sources": [],
  "recommendations": [
    {
      "category": "student_recruitment",
      "priority": "High",
      "issue": "Lower yield rate compared to competitors",
      "recommendation": "Enhance post-admission engagement programs",
      "expected_impact": "Increase yield rate by 5-8%"
    },
    {
      "category": "student_experience",
      "priority": "Medium",
      "issue": "Campus life satisfaction below target",
      "recommendation": "Improve student support services and campus facilities",
      "expected_impact": "Increase satisfaction by 3-5 points"
    }
  ],
  "comparative_insights": {
    "market_positioning": "Premium tier with strong employability focus",
    "competitive_advantages": [
      "Strong industry connections",
      "High placement rates"
    ],
    "improvement_areas": [
      "Cost accessibility",
      "Diversity in certain programs"
    ]
  },
  "course_finder_integration": {
    "search_analytics": {
      "total_searches": 16000,
      "unique_searchers": 9000,
      "search_trends": {
        "monthly_data": [
          {
            "month": "2024-01",
            "searches": 1300,
            "applications": 50
          }
        ]
      }
    },
    "student_preferences": {
      "top_concerns": [
        "employability",
        "cost",
        "location"
      ],
      "preferred_features": [
        "industry_connections",
        "scholarships",
        "career_services"
      ]
    },
    "application_funnel": {
      "awareness_to_search": 68,
      "search_to_application": 13,
      "application_to_enrollment": 9
    }
  },
  "cached": false,
  "timestamp": "2025-08-29T18:52:31.007781",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid",
  "metadata": {
    "analysis_type": "enhanced_consumer_insights",
    "country": "UK",
    "total_universities": 2,
    "course": "MBA",
    "response_time": 7.29,
    "data_sources": [
      "AI-Powered Course Finder",
      "University Reports",
      "Student Surveys",
      "Graduate Outcomes"
    ],
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "enhanced_consumer_insights_v1",
      "web_search_used": false,
      "course_finder_integration": true,
      "total_evidence_sources": 0
    }
  }
};
